<template>
    <!-- Попап с введением суммы для перехода на платежную систему -->
    <vs-popup class="pay_popup" :title="title" :active.sync="popupActive">
        <form v-if="payData">
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    <vs-input class="w-full" v-validate="'required'" name="amount" :label="$t('enter_amount')" v-model="amount" />
                    <span class="text-danger text-sm" v-show="errors.has('amount')">{{ $t('validation_required') }}</span>
                </div>
            </div>
            <vs-button
                type="filled"
                :disabled="disabled"
                @click.prevent="submitForm"
                class="mt-4 block pay_btn w-full lg:w-auto">
                    {{$t('pay')}}
            </vs-button>
        </form>
    </vs-popup>
</template>

<script>
export default {
    data() {
        return {
            amount: '',
            disabled: false
        }
    },
    computed: {
        popupActive: {
            get() {
                return this.$store.state.finance.payPopup
            },
            set(val) {
                if(!val) {
                    this.disabled = false
                    this.amount = ''
                    this.$validator.reset()
                }

                this.$store.commit('finance/SET_PAY_POPUP', val)
            }
        },
        payData() {
            return this.$store.state.finance.payData
        },
        title() {
            // Меняем заголовок попап окна
            if(this.payData)
                return `${ this.$t('pay_contract') } №${ this.payData.contract_number }`
            else
                return this.$t('pay')
        }
    },
    created: function() {
        if(this.payData && this.payData.summ) {
            this.amount = Number(JSON.parse(JSON.stringify(this.payData.summ)))
        }
    },
    methods: {
        submitForm() {
            // Если форма прошла валидацию, получаем данные для пепеадресации с сервера, и перенаправляем пользователя на платежную систему с ссылке в ключе operation_url
            this.$validator.validateAll().then(async result => {
                if(result) {
                    try {
                        this.$vs.loading({
                            container: '.pay_btn',
                            scale: 0.6
                        })

                        // const operation_url = `${ window.location.href }?contract_uid=${ this.payData.uid }`

                        const {data} = await this.$http.post(`/finance/contracts/${ this.payData.uid }/online_payment/`, {
                            amount: this.amount
                            //operation_url
                        })
                        if(typeof data === 'object')
                            window.location.replace(data.operation_url)
                    } catch(e) {
                        this.$vs.notify({
                            text: this.$t('error'),
                            color: 'danger',
                        })
                    } finally {
                        this.disabled = true
                        this.$vs.loading.close('.pay_btn > .con-vs-loading')
                    }
                } else
                    return false
            })
        }
    }
}
</script>

<style lang="scss">
.pay_popup{
    .pay_btn{
        position: relative;
        .con-vs-loading{
            position: absolute;
        }
    }
    .vs-popup{
        max-width: 400px;
    }
}
</style>
